import React from "react";
import Table from "react-bootstrap/Table";
import "../../../_static/instrument.css"
import InstrumentSelector from "./InstrumentSelector";
import UnpackButton from "../../../../buttons/UnpackButton";
import DeleteButton from "../../../../buttons/DeleteButton";

function InstrumentInstallationTable(props) {
    function selectInstrument(event, index) {
        props.selectInstrument(event, index)
    }

    return (
        <div>
            {!props.empty &&
                <div className="d-flex mb-3">
                    {props.unpackable===true && <UnpackButton onClick={props.unpackSection}/>}
                    <DeleteButton height="30" width="30"
                                  onClick={() => props.deleteInstrument(props.instrumentIndex)}/>
                </div>
            }
            <Table responsive striped bordered hover className="InstrumentTable ">
                <thead className="table-dark">
                <tr>
                    <th>SNR</th>
                    <th>Typ</th>
                    <th>Názov</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                        <InstrumentSelector value={!props.empty ? props.instrument.Pristroj : ""}
                                            selectInstrument={props.selectInstrument}
                                            instrumentIndex = {props.instrumentIndex}
                                            data={props.data}
                                            optionDisplay="SNR"
                                            ndx={props.ndx}
                                            index={null}
                                            stateResetOnChange={true}
                                            empty={props.empty}
                        />
                    </td>
                    <td>{!props.empty && props.instrument.Pristroj.Produkt && props.instrument.Pristroj.Produkt.Typ}</td>
                    <td>{!props.empty && props.instrument.Pristroj.Produkt && props.instrument.Pristroj.Produkt.Nazov}</td>
                </tr>
                </tbody>
            </Table>
        </div>
    )
}

export default InstrumentInstallationTable
